import { render, staticRenderFns } from "./DinamicaIva.vue?vue&type=template&id=4892cbf4&"
import script from "./DinamicaIva.vue?vue&type=script&lang=js&"
export * from "./DinamicaIva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports